var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07088 0.648363C9.41462 -0.216122 10.5854 -0.216121 10.9291 0.648365L12.9579 5.75071C13.1029 6.11516 13.4306 6.36417 13.8067 6.39571L19.0727 6.83732C19.9649 6.91215 20.3267 8.07684 19.6469 8.68594L15.6348 12.2809C15.3482 12.5378 15.223 12.9407 15.3106 13.3246L16.5363 18.6999C16.744 19.6106 15.7969 20.3305 15.033 19.8424L10.5245 16.9619C10.2025 16.7561 9.7975 16.7561 9.47548 16.9619L4.96699 19.8424C4.20311 20.3305 3.25596 19.6106 3.46363 18.6999L4.68942 13.3246C4.77698 12.9407 4.65182 12.5378 4.36526 12.2809L0.353062 8.68594C-0.326718 8.07684 0.0350679 6.91215 0.927291 6.83732L6.19336 6.39571C6.5695 6.36417 6.89716 6.11516 7.04207 5.75071L9.07088 0.648363Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.52f2b7e5ae43143bdbbcdd094c498182.svg";
export { ForwardRef as ReactComponent };